/**
 * Fixed Market Round / lobby company palette (Company 1–5).
 * `primary` is the visible team accent; `secondary` points to the SCSS-backed
 * brighter companion used by `.team-box--my-team`.
 * Keep in sync with `$market-round-team-company-*` in `stylesheets/base/_variables.scss`.
 */
export const MARKET_ROUND_TEAM_PAIRS = [
  { primary: '#EC4D45', secondary: 'var(--market-round-team-company-1-secondary)' },
  { primary: '#0E8589', secondary: 'var(--market-round-team-company-2-secondary)' },
  { primary: '#CA2298', secondary: 'var(--market-round-team-company-3-secondary)' },
  { primary: '#0B7DF9', secondary: 'var(--market-round-team-company-4-secondary)' },
  { primary: '#D98508', secondary: 'var(--market-round-team-company-5-secondary)' }
]

export const MARKET_ROUND_TEAM_PALETTE = MARKET_ROUND_TEAM_PAIRS.map((p) => p.primary)

/** When team id is missing from the game roster map (loading edge case). */
export const MARKET_ROUND_TEAM_COLOR_FALLBACK = '#6d6d6d'

export const MARKET_ROUND_TEAM_COLOR_PAIR_FALLBACK = {
  primary: MARKET_ROUND_TEAM_COLOR_FALLBACK,
  secondary: MARKET_ROUND_TEAM_COLOR_FALLBACK
}
